import * as ID from "../config/id/constant";
import * as PH from "../config/ph/constant"; 

const COUNTRY = process.env.REACT_APP_COUNTRY_CODE || "id";

let COUNTRY_CONSTANTS;

switch (COUNTRY) {
  case "id":
    COUNTRY_CONSTANTS = ID;
    break;
  case "ph":
  default:
    COUNTRY_CONSTANTS = PH;
}

export const {
  API_URL,
  APIV,
  apikey,
  CURRENCY_SYMBOL,
  DOC_UPLOAD_VALIDATION,
  FIELD_TYPE,
  ADD_ONS_TYPE,
  REGEX_DECIMAL_VALIDATION,
  REDIRECT_URLS,
  AGENT_WEB,
  REDIRECT_URL,
  INS_TYPE_COMPREHENSIVE,
  INS_TYPE_CTPL,
  STATUS_TYPE,
  LEAD_LIST_HEADER_COLUMN,
  LEAD_LIST_FILTER,
  REGEX_DECIMAL_VALIDATION_8,
  WITH_RULE_ENGINE,
  WITHOUT_RULE_ENGINE,
  DOCUMENT_CATEGORY,
  REGEX_EMAIL_VALIDATION,
  APP_TYPE_AGENCY,
  CLAIM_TYPE_CREATED_SOURCE,
  EFFECTIVITY_EXPIRY_INTERVAL,
  STATUS_CODES,
  SCREEN_SIZE,
  REGEX_NUMBER_WITH_TWO_DECIMAL,
  DEFAULT_PAGE_NO,
  DEFAULT_PAGINATION_COUNT,
  DEFAULT_INPUTFIELD_LENGTH,
  MAX_FILE_UPLOAD,
  MAX_OTP_TIMER,
  REGEX_EMAIL,
  REGEX_MOBILE,
  REGEX_CAMEL_CASE,
  BIKE_INS_VEHICLE_TYPE_ID,
  COMMERCIAL_BIKE_INS_VEHICLE_TYPE_ID,
  API_VERSION_V2,
  DOC_COLOR_CODE,
  COUNTRY_CODE,
  LEAD_LIST_HEADER_COLUMN_ID,
  STATUS_TYPE_ID,
  CURRENCY_CODE,
  LOGIN_TYPE,
  CHANGE_PASSWORD_STEP,
  OTP_INDEXES,
  MOVE_TO_BASIC_IDS, 
  DISCOUNT_TYPE,
  PAYMENT_GENERATE_WEB_SOURCE,
  SUBTRACT_YEAR,
  ALLOW_MONTH,
  LAST_MONTH,
  OCR_EXIST_PARENT_ID,
  MAX_MOBILE_LENGTH,
  LEAD_TYPE,
  DOC_IDS
} = COUNTRY_CONSTANTS;
